import React, { Component } from "react";
import ReactDOMServer from "react-dom/server";

import { Button } from "react-bootstrap";

import "./leaflet/leaflet.css";
import L from "leaflet";
import {markerClusterGroup} from "leaflet.markercluster";
import {siteName, siteAccessCode, siteCSZCombo, siteLastContact, 
  siteGeoCode, siteGeoLocation, validAccessCode,} from "../database/apiv2SiteAccessor";
import {ContactQuality, ContactDaysAgo, ContactStyle, ContactAge,
      } from "../Decorators/Checkmarks";
import Disconnect from '../Sites/Disconnect.js'
import LeafletIcons from "./LeafletIcons";
import Search from "../Search/Search";
import RenderSearch from "../Search/RenderSearch";
import Overview from "../Overview/Overview";
import SiteAdd from "../Sites/SiteAdd";
import { MapRect, RectCenter } from "./MinRect";
import SiteListEditModal from "./SiteListEditModal";
import { inRange, siteListContent } from "./siteNames";
import Footer from "../navbar/footer.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEdit } from "@fortawesome/free-solid-svg-icons";
import { renderLoader } from "../Loading/loading";
import { SiteFail } from "../Sites/SiteGuideRender.js";

import "../panels.css";
import "./leaflet_intro.css";
import "../Overview/devicehealth.css";
import '../../node_modules/leaflet.markercluster/dist/MarkerCluster.css'
import '../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css'

const ACCURATE = 0;

const RENDERMAP = "map";
const RENDERSITE = "overview";

export default class LeafletMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderTarget: RENDERMAP,
      siteModal: false,
      showSiteListEditModal: false,
      nodeIdForEdit: "",
      accessCodeToEdit: "",
      siteListNameToEdit: "",
      healthFilter: [0, Number.MAX_VALUE],
      filterLabel: "All",
      isLoading: false,
      siteFail: false,
      loader: renderLoader()
    };
    this.mapboxToken = process.env.REACT_APP_MAPBOX;
    this.geoCodeSuffix = '.json?access_token='+this.mapboxToken
    this.mymap = null;
    this.markerCluster = undefined
    this.visiblePop = null;
    this.mapMarkerClick = this.mapMarkerClick.bind(this);
    this.mapButtonClickHandler = this.mapButtonClickHandler.bind(this);
    this.setHealthFilter = this.setHealthFilter.bind(this);
    this.hideSiteListEditModal = this.hideSiteListEditModal.bind(this);
    this.changeSite = this.changeSite.bind(this);
    this.logoClick = this.logoClick.bind(this)
    this.mapIcons = null;
    this.prevButton = null;
    this.popContent = null;
    this.idKey = 1;
  }

  async componentDidMount() {
    this.props.setActiveSite(null)
    this.newMap();
  }
  async componentDidUpdate(prevProps, prevState) {
    if ((prevProps?.sites && prevProps.sites?.size !== this.props?.sites.size) ||
      (prevProps.content !== this.props.content)) {
      this.newPins(prevProps)
    }
    if (prevState.renderTarget !== this.state.renderTarget && this.state.renderTarget === RENDERMAP){
      this.newMap()
      //this.newPins(prevProps)
    }
  }
  newMap() {
    if (!this.isIterable(this.props.sites)) {
      this.setState ({isLoading: false, siteFail: true})
      return
    }
    if (this.mymap) {
      this.mymap.remove();
      this.markerCluster = undefined
    }
//    console.log (this.props.sites)
    const arrSites = [...this.props.sites.values()]
    this.clearMarkers(arrSites)
    const view = this.props.mapView();
    const initRect = MapRect (arrSites)
    const mapcenter = RectCenter(initRect); //[38.552,-96.421]
    const mapbounds = view?.loc ?? this.initBounds(initRect)
    const mymap = L.map("leafletMap", {center: mapcenter, preferCanvas: true})
    mymap.fitBounds(mapbounds)
    const attrib =
      'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution: attrib, maxZoom: 19, minZoom: 3,
        id: "mapbox/streets-v11", tileSize: 512,
        zoomOffset: -1, accessToken: this.mapboxToken,
      }).addTo(mymap);
    this.mapIcons = new LeafletIcons({ data: mymap, ...this.props });
    this.clusterMarkers(arrSites, mymap)
    this.mymap = mymap;
    this.setState ({isLoading: false})
  }
  newPins (prevProps) {
    const prevSites = [...prevProps.sites.values()]
    this.clearMarkers (prevSites)
    const newSites = [...this.props.sites.values()]
    this.clusterMarkers(newSites, this.mymap)
  }
  initBounds(rect) {
    const lCorner1 = L.latLng(rect.x1, rect.y1)
    const lCorner2 = L.latLng(rect.x2, rect.y2)
    return L.latLngBounds(lCorner2, lCorner1)
  }
  mapMarkerClick(e) {
    const popup = e.target.getPopup();
    this.activateMapPopup(popup);
  }

  activateMapPopup(popup) {
    if (this.prevButton) {
      L.DomEvent.removeListener(this.prevButton, "click", this.mapButtonClickHandler);
      this.prevButton = null;
      this.popContent = null;
    }
    if (popup !== null) {
      this.popContent = popup.getContent();
      const button = popup.getElement(); // UNDEFINED for off map clicks
      if (button)
        L.DomEvent.addListener(button, "click", this.mapButtonClickHandler);
      else {
        const altElement = document.querySelector(
          "div.leaflet-popup.leaflet-zoom-animated"
        );
        if (altElement)
          L.DomEvent.addListener(altElement, "click", this.mapButtonClickHandler);
      }
      this.prevButton = button;
    }
  }

  mapButtonClickHandler(e) {
    if (this.popContent) {
      if (e?.target?.parentElement?.className === 'leaflet-popup-close-button') {
        L.DomEvent.removeListener(this.prevButton, "click", this.mapButtonClickHandler);
        this.prevButton = null;
        this.popContent = null;
        return
      }
      const key = this.popContent.indexOf(' name="')
      const ac = this.popContent.slice(key+7,key+18)
      const cache = this.props.siteMap()
      const clickedSite = cache.get(ac)
      if (typeof clickedSite !== "undefined") {
        this.cacheMapView();
        this.props.setActiveSite(clickedSite);
        this.setState({ renderTarget: RENDERSITE });
      } else {
        console.log(this.popContent);
        console.log(this.props.siteMap());
      }
    }
  }
  cacheMapView() {
    if ("function" === typeof this.props.mapView) {
      //let loc = [this.mymap.getCenter().lat, this.mymap.getCenter().lng];
      const loc = this.mymap.getBounds()
      const zoom = this.mymap.getZoom();
      this.props.mapView(loc, zoom);
    }
  }

  siteModal(show) {
    this.setState({ siteModal: show });
  }
  clusterMarkers(sites, map) {
    if (!sites || !this.isIterable(sites)) return
    map.whenReady(() => {
      this.markerCluster = L.markerClusterGroup()
      for (const site of sites) {
        site.pinStyle ??= ACCURATE;
        this.addMarker(site)
      }
      map.addLayer(this.markerCluster)
    })
  }
  addMarker(site) {
    if (siteGeoLocation(site) && !site?.mapMarker) {
      const style = ContactStyle(ContactAge({site: site}))
      const marker = L.marker(siteGeoLocation(site), 
        {icon: this.mapIcons.fromAttributes(style, site.pinStyle), });
      this.markerCluster.addLayer(marker)
      this.setMarker(marker, site)
    }
  }
  setMarker(marker, site) {
    marker.bindPopup(this.mapPopupButton(site));
    marker.on("click", this.mapMarkerClick);
    site.mapMarker={marker: marker}
  }
  clearMarkers(sites) {
    this.markerCluster && this.markerCluster.clearLayers()
    sites.forEach(s => s.mapMarker = undefined)
  }
  isIterable(input) {
    if (input === null || typeof input === 'undefined') {
      return false;
    }
    return typeof input[Symbol.iterator] === 'function';
  }
  mapPopupButton(site) {
    const htmlString = ReactDOMServer.renderToStaticMarkup(
      this.popupContent(site)
    );
    return (
      '<button id="popbtn" type="button" class="btn btn-sm" name="' +
      siteAccessCode(site) + '" data-sitename="' + siteName(site) +'">' +
      htmlString + "</button>"
    );
  }
  moveMapView(coords, site) {
    //this.mymap.setView(coords);
    this.mymap.panTo(coords);
    const wantedMarker = site?.mapMarker
    wantedMarker?.marker?.openPopup();
    wantedMarker?.marker &&
      this.activateMapPopup(wantedMarker.marker.getPopup());
  }

  scrollMap(site) {
    if (site?.site_details?.geo_location) {
      const coords = siteGeoCode(site);
      if (coords) {
        this.moveMapView(coords, site);
        return true;
      }
    }
    return false;
  }
  popMatch(site) {
    return (
      this.popContent &&
      this.popContent.includes(' name="' + siteAccessCode(site))
    );
  }
  nameClickHandler(site) {
    const element = document.getElementById(siteAccessCode(site));
    if (element == null) {
      // popover here
      return;
    }
    if (
      (this.visiblePop && this.visiblePop === element) ||
      this.popMatch(site)
    ) {
      this.popupClickHandler(site);
    }
    if (this.visiblePop && this.visiblePop !== element) {
      this.visiblePop.classList.toggle("hiding");
      this.visiblePop = null;
    }
    if (!this.scrollMap(site)) {
      element.classList.toggle("hiding");
      this.visiblePop = element;
    }
  }
  popupClickHandler(site) {
    if (validAccessCode(site)) {
      this.jumpTo(site);
    }
  }
  popupContent(site) {
    return validAccessCode(site)
      ? this.expectedPopupContent(site)
      : this.missingACPopupContent(site);
  }
  expectedPopupContent(site) {
    const lastContact = siteLastContact(site) ?? "Never";
    const quality = ContactQuality({ site: site });
    const allStyles = ["popup-red", "popup-yellow", "popup-green"];
    return (
      <div className="popup-content"
        onClick={() => this.popupClickHandler(site)}
      >
        <span className="popup-title">
          {siteName(site)}
          <br />
        </span>
        <span className="popup-line2">
          {siteCSZCombo(site) || "No address"}
        </span>
        <br />
        <span className={"popup-line3 " + allStyles[quality]}>
          Last Updated {lastContact}
        </span>
      </div>
    );
  }
  missingACPopupContent(site) {
    return (
      <div className="popup-content">
        <span className="popup-title">
          {siteName(site)}
          <br />
        </span>
        <span className="popup-line2">
          {siteCSZCombo(site) || "No address"}
        </span>
        <br />
        <span className={"popup-line3 popup-red"}>
          Incomplete site data. No details available
        </span>
      </div>
    );
  }
  siteListEditModal(site) {
    // console.log("NODE ID: ", site.nodeId);
    this.setState({
      showSiteListEditModal: true,
      nodeIdForEdit: site.nodeId,
      accessCodeToEdit: siteAccessCode(site),
      siteListNameToEdit: siteName(site),
    });
  }
  hideSiteListEditModal() {
    this.setState({ showSiteListEditModal: false });
  }
  siteNamesList() {
    const pv = [{ "--bot": "-50%" }, { "--bot": "-25%" }, { "--bot": "100%" }];
    const sites = this.props?.sites ?? []
    const arrSites = Array.isArray(sites) ? sites : [...this.props.sites.values()]
    return (
      <ul className="list-group" key="sites">
        {arrSites?.map((site, index) =>
            this.siteNameItem(site, index, index > 2 ? pv[2] : pv[index])
          )}
      </ul>
    );
  }
  /*  inRange (daysAgo) {
    return daysAgo >= this.state.healthFilter[0] && daysAgo < this.state.healthFilter[1]
  }*/
  siteNameItem(site, index, cssParam) {
    const content = siteListContent(site);
    return inRange(ContactDaysAgo({ site: site }), this.state.healthFilter) ? (
      <li key={index}
        className="sitelist-item d-flex align-items-center left-pane-popup-container">
        <div className="site-main"
          style={{ cursor: "pointer" }}
          onClick={() => this.nameClickHandler(site)}>
          {content[0]}
          <div className="list-site-ac">
            {content[1]} {content[2]}
          </div>
          <span id={siteAccessCode(site)}
            className="left-pane-popup hiding"
            style={cssParam} onClick={() => this.popupClickHandler(site)}>
            {this.popupContent(site)}
          </span>
        </div>
        <div className="site-icons">
          <span className="site-edit" onClick={() => this.siteListEditModal(site)}>
            <FontAwesomeIcon icon={faEdit} color="white" />
          </span>
          <span className="site-button" onClick={() => this.jumpTo(site)}>
            <FontAwesomeIcon icon={faArrowRight} className="site-arrow" />
          </span>
        </div>
      </li>
    ) : null;
  }
  jumpTo(site) {
    //Tour code
    this.props.updateSiteLocation("overview");
    this.props.launchTourStatus(true);
    //Tour end code

    this.props.setActiveSite(site);
    this.setState({ renderTarget: RENDERSITE });
  }
  setHealthFilter(item, display) {
    const sanity = display ?? "";
    if (item !== "undefined") {
      this.setState({ healthFilter: item, filterLabel: sanity });
    } else {
      const toggle = this.state.healthFilter === 2 ? 1 : 2;
      this.setState({ healthFilter: toggle });
    }
  }
  changeSite() {
    Disconnect(this.props)
    this.props.clearCrumb()
    this.setState({ renderTarget: RENDERMAP });
  }
  logoClick() {
    Disconnect (this.props)
    window.location.href = "/";
  }
  renderMain () {
    if (this.state.isLoading)
      return <div className="main-pane" id="loader">{this.state.loader}</div>
    else if (this.state.siteFail)
      return <SiteFail />
    else {
      return <div className="main-pane" id="leafletMap" />
    }
  }
  render() {
    if (this.state.renderTarget === RENDERSITE)
      return <Overview {...this.props} changeSite={this.changeSite} />;
    return (
      <div className="content-container">
        <SiteAdd {...this.props} show={this.state.siteModal}
          hide={() => this.siteModal(false)} />
        <SiteListEditModal
          {...this.props}
          nodeIdForEdit={this.state.nodeIdForEdit}
          accessCodeToEdit={this.state.accessCodeToEdit}
          siteListNameToEdit={this.state.siteListNameToEdit}
          show={this.state.showSiteListEditModal}
          hide={this.hideSiteListEditModal}
        />
        <div className="left-hand-pane">
          <img src="tehama_logo_100p.png" className="nav-logo" 
            onClick={this.logoClick}
            alt="Tehama Logo"></img>
          <div className="title-vert-spacer">
            <span className="list-title">Site List</span>
            <Button className="site-add-button" onClick={() => this.siteModal(true)}>
              +&nbsp;&nbsp;Add Site
            </Button>
          </div>
          <div className="vertical-spacer">
            <Search onChange={this.props.siteFilter} filterText={this.props?.filterText}> 
              <RenderSearch {...this.props} /> 
            </Search>
          </div>
          <div className="left-hand-content styled-scrollbars">
            {this.siteNamesList()}
          </div>
        </div>
        {this.renderMain()}
        <Footer className="footer-pane" filter={this.setHealthFilter}
          {...this.props} {...this.state} />
      </div>
    );
  }
}
//        <div className="main-pane" id="leafletMap" />
